import Importer from './Importer';
import Dot from '../track/Dot';
import Dots from '../track/Dots';

export default class ImporterKML extends Importer {
  constructor(fileName, fileData) {
    super(fileName, fileData);
    this.SEGMENTS_TAG = 'coordinates';
  }

  import() {
    let dots = new Dots();

    let file = this.parseFile();

    let segments;
    let segmentsArr;
    let usesPoints = false;
    if (file.getElementsByTagName('Point').length > 0) {
      segments = file.getElementsByTagName('Point');
      segmentsArr = segments;
      usesPoints = true;
    } else {
      segments = file.getElementsByTagName(this.SEGMENTS_TAG)[0];
      segmentsArr = segments.innerHTML.split('\n');
    }

    let error = file.getElementsByTagName('parsererror')[0];

    if (error) throw new Error(error.getElementsByTagName('div')[0].innerHTML);

    let oldDot;
    let newDot;
    for (let i = 0; i < segmentsArr.length; i++) {
      if (segmentsArr[i].toString().trim().length === 0) {
        // eslint-disable-next-line no-console
        console.warn('Zero length line, skipping');
        // eslint-disable-next-line no-continue
        continue;
      }
      // dots is an object so it's always passed by reference in JS
      let coords;
      if (usesPoints) {
        coords = segmentsArr[i].firstElementChild.innerHTML.toString().trim().split(',');
      } else {
        coords = segmentsArr[i].toString().trim().split(',');
      }
      if (coords[0] && coords[1]) {
        newDot = new Dot(parseFloat(coords[1]), parseFloat(coords[0]));
        // eslint-disable-next-line max-len
        if (oldDot && (oldDot.getLatitude() !== newDot.getLatitude()) && (oldDot.getLongitude() !== newDot.getLongitude())) {
          dots.add(newDot);
        } else if (!oldDot && newDot) {
          dots.add(newDot);
        }
        oldDot = newDot;
      } else {
        // eslint-disable-next-line no-console
        console.warn(segmentsArr[i]);
        throw new Error('Malformed file');
      }
    }

    return dots;
  }

  parseFile() {
    let parser = new DOMParser();
    return parser.parseFromString(this._fileData, 'application/xml');
  }
}
